/**
 * Feature guide (功能说明书): the guide button in the page header, the side panel / bottom sheet and the first-visit
 * hint. One row per key: [key, English, 中文, Bahasa Melayu]. Registered in ../modules.ts + en/zh/ms.ts.
 * The guide CONTENT itself is docs/help/guide/*.md (en + zh).
 */
const ROWS = [
  ["gd.button","Guide","说明书","Panduan"],
  ["gd.buttonLong","Page guide","功能说明书","Panduan halaman"],
  ["gd.title","Guide: {page}","说明书：{page}","Panduan: {page}"],
  ["gd.what","What this page is for","这个页面是做什么的","Untuk apa halaman ini"],
  ["gd.steps","How to use it","怎么用","Cara guna"],
  ["gd.settings","Key settings explained","重要设置说明","Tetapan utama"],
  ["gd.tips","FAQ & tips","常见问题 / 小提示","Soalan lazim & tip"],
  ["gd.full","Read the full tutorial","看完整教程","Baca tutorial penuh"],
  ["gd.fullHide","Hide the full tutorial","收起完整教程","Sembunyi tutorial penuh"],
  ["gd.fullLoading","Loading the tutorial…","正在加载教程…","Memuatkan tutorial…"],
  ["gd.fullError","The tutorial could not be loaded.","教程加载失败。","Tutorial tidak dapat dimuatkan."],
  ["gd.ask","Ask Senvia Assistant","问 Senvia 助手","Tanya Pembantu Senvia"],
  ["gd.askPrefill","I'm on the \"{page}\" page. My question: ","我在「{page}」页面，想问：","Saya di halaman \"{page}\". Soalan saya: "],
  ["gd.close","Close the guide","关闭说明书","Tutup panduan"],
  ["gd.loading","Loading the guide…","正在加载说明书…","Memuatkan panduan…"],
  ["gd.firstHint","First time here? Read the guide","第一次用？看说明书","Kali pertama? Baca panduan"],
  ["gd.dismiss","Dismiss","不再提示","Tutup"],
  ["gd.plan.base","All plans","所有方案可用","Semua pelan"],
  ["gd.plan.full","Full plan","Full 方案","Pelan Full"],
  ["gd.plan.addon","Add-on · included in Full","附加功能 · Full 方案已包含","Tambahan · termasuk dalam Full"],
  ["gd.plan.on","On for your shop","你的店已开通","Aktif untuk kedai anda"],
  ["gd.plan.off","Not on for your shop yet","你的店尚未开通","Belum aktif untuk kedai anda"],
] as const;

export type GdKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2 | 3) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<GdKey, string>;

export const taskGD = { en: col(1), zh: col(2), ms: col(3) };
